var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharenewsAdvertisement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advertisment-Browser-Online-Megaphone-Commerce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10 55v-3h19v-2h-24a1 1 0 0 1 -1-1v-37h46v17h2v-12h4v10h2v-16a3 3 0 0 0 -3-3h-3v-3a3 3 0 0 0 -3-3h-44a3 3 0 0 0 -3 3v44a3 3 0 0 0 3 3h3v3a3 3 0 0 0 3 3h25v-2h-25a1 1 0 0 1 -1-1zm45-45a1 1 0 0 1 1 1v4h-4v-5zm-50-6h44a1 1 0 0 1 1 1v5h-46v-5a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 55a1 1 0 0 1 -1 1h-6v2h6a3 3 0 0 0 3-3v-4h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 6h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 28a1 1 0 0 0 1-1v-10a1 1 0 0 0 -1-1h-12a1 1 0 0 0 -1 1v10a1 1 0 0 0 1 1zm-11-10h10v8h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 16h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 16h8v2h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 20h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 24h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 28h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 32h18v2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 36h18v2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 40h18v2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 44h18v2h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.805 50.465 7.565-1.09a2.983 2.983 0 0 0 3.656.527 3.005 3.005 0 0 0 1.1-4.1l-2.5-4.33a3 3 0 0 0 -3-5.2l-2.5-4.33a3 3 0 0 0 -5.471 2.334l-6.186 7.86-5.03 2.9a3.005 3.005 0 0 0 -1.1 4.1l2 3.464a3 3 0 0 0 4.1 1.1l3.5 6.062a3 3 0 0 0 4.1 1.1l1.732-1a3 3 0 0 0 1.1-4.1zm9.185-12.09a1 1 0 0 1 -.365 1.366l-1-1.732a1 1 0 0 1 1.365.366zm-7.964-5.793a1 1 0 0 1 1.366.365l8 13.857a1 1 0 1 1 -1.731 1l-8-13.857a1 1 0 0 1 .365-1.365zm-1.359 3.644 6.523 11.3-8.529 1.228-3.323-5.754zm-6.9 8.052 3 5.2-1.732 1-3-5.2zm-2.7 7.33-2-3.464a1 1 0 0 1 .366-1.366l.866-.5 3 5.2-.866.5a1 1 0 0 1 -1.361-.37zm10.7 6.526-1.732 1a1 1 0 0 1 -1.366-.366l-3.5-6.062 3.3-1.9.2-.029 3.461 5.995a1 1 0 0 1 -.362 1.362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.187 34.375h4v2h-4z",
    transform: "matrix(.866 -.5 .5 .866 -9.892 33.835)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.016 30.363h4.243v2h-4.243z",
    transform: "matrix(.259 -.966 .966 .259 9.831 75.538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.638 38.768h2v4.243h-2z",
    transform: "matrix(.259 -.966 .966 .259 4.707 87.912)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharenewsAdvertisement);
export default __webpack_public_path__ + "static/media/sharenews_advertisement.ead7a3fa.svg";
export { ForwardRef as ReactComponent };